export const argoCDTemplatePatchSchema = {
  type: 'string',
  // Every part of this pattern is load bearing.
  //
  // The original `(\s\s.*\n?)*` backtracked exponentially on a non-matching
  // input because `\s` also matches `\n`, so a line could be consumed by either
  // the group's own `\s\s` or its trailing `\n?`. This validator runs on the UI
  // thread on every render while the form has errors; at ~28 lines that regex
  // took seconds and froze the page.
  //
  // The body is therefore matched one line at a time. A line is either indented
  // by at least two spaces/tabs (`[ \t]{2}[^\n]*`) or blank (`[ \t]?`, i.e.
  // empty or a single stray space/tab). Blank lines are normal inside a
  // multi-section YAML block scalar, and the stored `spec.templatePatch` of
  // already-deployed ApplicationSets is decoded back into this field in edit
  // mode, so rejecting them would make those projects unsaveable.
  //
  // The two alternatives must stay mutually exclusive on any given line, and
  // each iteration must end on a line boundary - that is what keeps matching
  // linear. The obvious `[ \t]*` instead of `[ \t]?` makes the alternation
  // ambiguous and hangs.
  pattern: '^templatePatch: \\|\\n(?:(?:[ \\t]{2}[^\\n]*|[ \\t]?)(?:\\n|$))*$',
  title: 'Template Patch',
  description:
    'Must start with "templatePatch: |" (no leading/trailing spaces), followed by lines indented with at least 2 spaces. Blank lines are allowed.',
};
